export default __webpack_public_path__ + "media/images/react_icons/share_booking-e3f02831ef067caf65d1d3a90fbf1c2a.svg";